import { DowngradeFlowValidation } from "@/components/downgrade-flow";
import { Button } from "@/components/ui/button";
import { ProtectedWrapper } from "@/providers/protected-wrapper";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/downgrade")({
  component: Downgrade,
});

function Downgrade() {
  return (
    <ProtectedWrapper>
      <div className="max-w-5xl mx-auto p-4 md:p-6 min-h-screen">
        <Button asChild>
          <Link
            to="/dashboard"
            className="rounded-full text-sm flex items-center gap-2 w-fit"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Back to Dashboard</span>
          </Link>
        </Button>
        <div className="flex items-center mb-6 mt-3 gap-2">
          <h1 className="page-heading">Downgrade Your Plan</h1>
        </div>

        <DowngradeFlowValidation />
      </div>
    </ProtectedWrapper>
  );
}
